export default {"src":"/_next/static/media/left-right-arrow.4f0da101.svg","height":8,"width":8};